class MessageTerminal extends BaseService
	@register()
	@inject '$rootScope', 'MessageTypes'

	initialize: ->
		@events = @MessageTypes

	publish: (messageType, ...data) ->
		@$rootScope.$broadcast(messageType, data)

	on: (scope, messageType, callback) ->
		scope.$on messageType, (event, data) =>
			if !_.isArray data
				data = [data]

			callback.call(scope, ...data)

	onSave: (scope, callback) ->
		@on scope, @events.CRUD.SAVE, callback

	onDelete: (scope, callback) ->
		@on scope, @events.CRUD.DELETE, callback

	afterSave: (isNew = false, ...data) ->
		if isNew
			@afterCreate(...data)
		else
			@afterUpdate(...data)

	afterUpdate: (...data) ->
		@publish @events.CRUD.UPDATE, ...data

	afterCreate: (...data) ->
		@publish @events.CRUD.ADD, ...data

	afterDelete: (...data) ->
		@publish @events.CRUD.REMOVE, ...data
